import { ContentDefaults } from "./interfaces";

export const FORM_NAME = "moving";

export const CLOUDINARY_ENDPOINT =
  "https://res.cloudinary.com/originenergy/image/upload";

interface ImageDefaults {
  readonly QUALITY: number;
}

export const IMAGE_DEFAULTS: ImageDefaults = {
  QUALITY: 70,
};

export const FUEL = "fuel";
export const FUEL_KEY = "electricity-gas";
export const FUEL_ELEC = "Elec";
export const FUEL_GAS = "Gas";
export const FUEL_DUAL = "Elec_Gas";
export const INTERNET = "Internet";
export const LPG = "LPG";
export const LPG_OFFERS = "/lpg/offers/";
export const INTERNET_PLANS = "/internet/plans";
export const COMPARE_PLANS = "/electricity-gas/plans.html";
export const BUSINESS_PATH = "/business";
export const BUSINESS_COMPARE_PLANS = "/business/electricity-and-gas-plans";

export const CONTENT_TYPE_MOVE = "move";

export const BUTTON_SALES = "sales";
export const BUTTON_CP = "cp";

export const FEATURE_SIMPLE_MOVE_REDIRECT_TO_CUSTOMISATION_APP =
  "simple-move-redirect-to-customisation-app";

export const FEATURE_MOVERS_WIDGET_UPLIFT = "sales-movers-widget-uplift";

export const ADDRESS_ERROR_REQUIRED_DEFAULT =
  "Please enter your connection address...";
export const ADDRESS_ERROR_INVALID_DEFAULT =
  "Oops, that address doesn't look right...";

export const CONTENT: ContentDefaults = {
  move: {
    heading: "Moving house with Origin",
    description: "",
    backgroundImage: "",
    buttonLabelCP: "See plans and prices",
    buttonLabelSales: "Book my move",
    address: {
      label: "New connection address",
      errors: {
        required: ADDRESS_ERROR_REQUIRED_DEFAULT,
        invalid: ADDRESS_ERROR_INVALID_DEFAULT,
      },
    },
    selectFuel: {
      label: "What services would you like to connect?",
      errors: {
        required: "Please select a service...",
        invalid: "",
      },
    },
  },
  fuel: {
    heading: "Electricity and natural gas to suit your needs",
    description: "Power your home, how and when you like it",
    backgroundImage: "bcca08622875a03888acd7125008c92af05d67a4",
    buttonLabelCP: "See plans for your address",
    address: {
      label: "New connection address",
      errors: {
        required: ADDRESS_ERROR_REQUIRED_DEFAULT,
        invalid: ADDRESS_ERROR_INVALID_DEFAULT,
      },
    },
    selectFuel: {
      label: "Select a fuel type",
      errors: {
        required: "Please select a fuel type...",
        invalid: "",
      },
    },
  },
  disclaimer: {
    linkLabel: "Basic Plan Information/Energy Fact Sheets",
    link: "/pricing.html",
  },
};

export const LEGACY_MOVE_CONTENT: ContentDefaults["move"] = {
  ...CONTENT.move,
  buttonLabelCP: "Compare plans",
  buttonLabelSales: "Book my Move",
};

export const AUTH_ERROR = "[Movers Widget]: Authentication error";

export const BRAZE_SEGMENT_COOKIE = "bzid.aud_cohort";
